const CodificaString =(valor)=>{
    if (valor != null || valor != undefined){
        let  CodificaString1 = window.btoa(encodeURIComponent(valor));
        let  CodificaString2 = window.btoa(encodeURIComponent(CodificaString1));
        //let  CodificaString3 = window.btoa(encodeURIComponent(CodificaString2));
      
        return CodificaString2;
    
    }


}; 
const DecodificanString =(valor)=>{
    if (valor != null || valor != undefined){
       
        let valor1 = decodeURIComponent(window.atob(valor));
        let valor2 = decodeURIComponent(window.atob(valor1));
        //let valor3 = decodeURIComponent(window.atob(valor2));
       
        return valor2;
    }

}

export { CodificaString, DecodificanString }; //
